<template>
    <TopNav />
    <v-container class="home">
        <div class="home__left">
            <h1 class="font-medium">Energy of the future</h1>
            <p class="mb-5">
                At EnergyHub, we aim to enable the transition to sustainable
                energy in Malaysia. It is our mission to explore the potential
                of solar energy, and dive deep into the sun.
            </p>
            <SolidButton redirect="login" text="Get Started" />
        </div>
        <div class="home__right">
            <img :src="require('../assets/solar-panel-home-2.png')" />
        </div>
    </v-container>
    <v-container id="benefits" class="benefits pb-16">
        <h1 class="font-medium text-center mt-11 mb-8">Your Benefits</h1>
        <v-row class="text-center">
            <v-col class="benefits__box">
                <img
                    class="benefits__icon"
                    :src="require('../assets/benefits-money.png')"
                />
                <h3 class="font-medium">Make Money</h3>
                <p>Get paid to invest in solar energy for your home</p>
            </v-col>
            <v-col class="benefits__box">
                <img
                    class="benefits__icon"
                    :src="require('../assets/benefits-planet.png')"
                />
                <h3 class="font-medium">Save the Planet</h3>
                <p>Solar is a renewable source of energy</p>
            </v-col>
            <v-col class="benefits__box">
                <img
                    class="benefits__icon"
                    :src="require('../assets/benefits-service.png')"
                />
                <h3 class="font-medium">Great Customer Service</h3>
                <p>Have a trained team of professionals support you</p>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import TopNav from "@/components/TopNav.vue";
import SolidButton from "@/components/SolidButton.vue";
export default {
    name: "HomeView",
    components: { TopNav, SolidButton },
};
</script>

<style lang="scss" scoped>
.home {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    &__left {
        width: 500px;
    }
    &__right {
        img {
            height: 400px;
        }
    }
}
.benefits {
    &__box {
        margin: 30px;
        padding: 40px 20px;
        box-shadow: -1px 10px 30px -2px rgba(0, 0, 0, 0.26);
        -webkit-box-shadow: -1px 10px 30px -2px rgba(0, 0, 0, 0.26);
        -moz-box-shadow: -1px 10px 30px -2px rgba(0, 0, 0, 0.26);
        border-radius: 25px;
    }
    &__icon {
        width: 60px;
    }
}
</style>
